// Product-usage events for Driventra CRM: which screens and controls hospital staff use, never what they show.
// Addresses and element names can carry patient or record identifiers (/ipd/admissions/482, ?patientId=…,
// id="row-482"), so everything that leaves the browser is reduced to a template first.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const LONG_HEX = /^[0-9a-f]{16,}$/i;

/** "/ipd/admissions/482/discharge-summary?patientId=9" -> "/ipd/admissions/:id/discharge-summary" */
export function pathTemplate(pathname: string): string {
  const path = pathname.split(/[?#]/)[0] || '/';
  const segments = path.split('/').map((segment) => {
    if (!segment) return segment;
    let decoded = segment;
    try {
      decoded = decodeURIComponent(segment);
    } catch {
      return ':id';
    }
    return /\d/.test(decoded) || UUID.test(decoded) || LONG_HEX.test(decoded) || decoded.includes('@') ? ':id' : segment;
  });
  return segments.join('/') || '/';
}

/** Element ids and classes with any digit run replaced, e.g. "row-482 active" -> "row-# active". */
export function anonymousToken(value: unknown, max = 200): string {
  return (typeof value === 'string' ? value : '').replace(/\d+/g, '#').slice(0, max);
}
